import { type } from 'arktype';

export const personCalendarSchema = type({
  id: 'string',
  name: 'string',
  type: "'global' | 'factory' | 'individual'",
}).configure({
  description: 'Calendar the person is attached to. The person\'s own calendar has `type: "individual"`.',
});

export const personCalendarListResponseSchema = type({
  data: personCalendarSchema.array(),
}).configure({ description: 'Calendars the person is attached to.' });
